const CONSTANTS = {
  LINKS: {
    HOME: {
      LABEL: "HOME",
      LINK: "/",
    },
    ABOUT_US: {
      LABEL: "ABOUT US",
      LINK: "/about",
    },
    APPLICATIONS: {
      LABEL: "USE CASES",
      LINK: "/use-cases",
    },
    TECHNOLOGY: {
      LABEL: "TECHNOLOGY",
      LINK: "/technology",
      PAGES: [
        {
          LABEL: "SYNTHETIC APERTURE RADAR",
          LINK: "/technology/sar",
        },
        {
          LABEL: "GROUND PENETRATING RADAR",
          LINK: "/technology/gpr",
        },
        {
          LABEL: "HYPERSPECTRAL IMAGING",
          LINK: "/technology/hyperspectral",
        },
        {
          LABEL: "OTHER PRODUCTS",
          LINK: "/technology/other-techs",
        },
      ],
    },
    BLOG: {
      LABEL: "BLOGS",
      LINK: "/blog",
    },
    CONTACT_US: {
      LABEL: "CONTACT US",
      LINK: "/contact",
    },
  },
  FOOTER: {
    PAGES: {
      HEADER: "PAGES",
      LINKS: [
        {
          LABEL: "Home",
          LINK: "/",
        },
        {
          LABEL: "About Us",
          LINK: "/about",
        },
        {
          LABEL: "Blogs",
          LINK: "/blog",
        },
      ],
    },
    APPLICATIONS: {
      HEADER: "USE CASES",
      LINKS: [
        {
          LABEL: "Defence",
          LINK: "/use-cases#defence",
        },
        {
          LABEL: "Agriculture",
          LINK: "/use-cases#agriculture",
        },
        {
          LABEL: "Mining",
          LINK: "/use-cases#mining",
        },
        {
          LABEL: "Urban Planning",
          LINK: "/use-cases#urban-planning",
        },
        {
          LABEL: "Environment",
          LINK: "/use-cases#environment",
        },
      ],
    },
    TECHNOLOGY: {
      HEADER: "TECHNOLOGY",
      LINKS: [
        {
          LABEL: "Synthetic Aperture Radar (SAR)",
          LINK: "/technology/sar",
        },
        {
          LABEL: "Ground Penetrating Radar (GPR)",
          LINK: "/technology/gpr",
        },
        {
          LABEL: "Hyperspectral Imaging",
          LINK: "/technology/hyperspectral",
        },
        {
          LABEL: "Other Products",
          LINK: "/technology/other-techs",
        },
      ],
    },
    BROCHURES: {
      HEADER: "BROCHURES",
      TYPES: [
        {
          LABEL: "Synthetic Aperture Radar (SAR)",
          ITEMS: ["Air SAR Alpha L Brochure.pdf", "SATSAR-Alpha-LP.pdf"],
          LINK: "/technology/sar#sar-brochures",
        },
        {
          LABEL: "Ground Penetrating Radar (GPR)",
          ITEMS: ["LMD-GPRX1-Indra.pdf", "OD-GPRX2  Bhumi.pdf"],
          LINK: "/technology/gpr#gpr-brochures",
        },
        {
          LABEL: "Hyperspectral Imaging",
          ITEMS: ["HySkyView-51.pdf"],
          LINK: "/technology/hyperspectral#hyperspectral-brochures",
        },
        {
          LABEL: "Other Products",
          ITEMS: [
            "NF-AMF- Hexahedron.pdf",
            "HFF-AMF- InnoWave 4.pdf",
            "VFF-AMF- InnoWave 4.pdf",
          ],
          LINK: "/technology/other-techs#other-products",
        },
      ],
    },
    CONTACT: {
      HEADER: "CONTACT",
      ADDRESS:
        "Corporate Office: Rishi Tower, 4th Floor, Street No 0366, DH Block, Action Area 1, Newtown, Kolkata – 700156.",
      REGD_OFFICE:
        "Registered Office: 1-1203 Casa Vyoma Tower, Vastrapur, Ahmedabad – 380015",
      CIN: "CIN: U32109GJ2021PTC125777",
      PHONE: "Phone: +91-9147063635",
      MAIL_ID: "Mail ID: namaskar@sisiradar.com",
    },
    LOCATION: {
      HEADER: "LOCATIONS",
      CONTENT: [
        "Corporate Office: Rishi Tower, 4th Floor, Street No 0366, DH Block, Action Area 1, Newtown, Kolkata – 700156.",
        "Registered Office: 1-1203 Casa Vyoma Tower, Vastrapur, Ahmedabad – 380015",
        "CIN: U32109GJ2021PTC125777"
      ]
    },
    QUERIES: {
      HEADER: "ENQUIRIES",
      CONTENT: [
        "Email: namaskar@sisirradar.com",
        "Phone: +91-9147063635"
      ]
      
    },
    FOLLOW_US: {
      HEADER: "FOLLOW US",
    },
  },
  BROCHURE_MODAL: {
    SUB_HEADER: "Fill in the details below to receive this brochure:",
    FORM: {
      FIRST_NAME: {
        LABEL: "First Name",
        MANDATORY: true,
      },
      LAST_NAME: {
        LABEL: "Last Name",
        MANDATORY: true,
      },
      PHONE: {
        LABEL: "Phone Number",
        MANDATORY: true,
      },
      EMAIL: {
        LABEL: "Email",
        MANDATORY: true,
      },
      ORGANISATION: {
        LABEL: "Organisation",
        MANDATORY: false,
      },
    },
    TERMS:
      "* By clicking this, you confirm that you have read and agree to Sisir Radar's Privacy Policy and consent to be contacted regarding your submission.",
    CTA: "Send Me the Brochure",
  },
  SOCIAL_LINKS: {
    FACEBOOK: "https://www.facebook.com/sisir.radar",
    LINKEDIN: "https://www.linkedin.com/company/sisir-radar/",
    TWITTER: "https://twitter.com/SisirRadar",
    INSTAGRAM: "https://www.instagram.com/sisir.radar/",
  },
  READ_MORE: "Read More",
  KNOW_MORE: "Know More",
  LEARN_MORE: "Learn More",
  HIDE: "Hide",
  KNOW_MORE_ABOUT_TECH: "KNOW MORE ABOUT THE TECHNOLOGY BEHIND",
  SEE_BROCHURES: "See Brochure(s)",
  BUTTONS: {
    CONTACT: "CONTACT NOW",
  },
  COPYRIGHT: "© 2025 Sisir Radar",
};

export default CONSTANTS;
